/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendVentureFundDividendDto } from '../../models/backend-venture-fund-dividend-dto';

export interface VentureFundsVentureFundDividendsCopyCreate$Params {
  id: number;
}

export function ventureFundsVentureFundDividendsCopyCreate(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundDividendsCopyCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundDividendDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundDividendsCopyCreate.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundDividendDto>;
    }),
  );
}

ventureFundsVentureFundDividendsCopyCreate.PATH = '/api/venture_funds/venture-fund-dividends/{id}/copy/';
